import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'

import { triggerGA4Events } from 'utils/helper-functions'
import useNavigate from 'utils/navigation/useCustomNavigate'
import { AppContext } from '../../../providers/context/App'
import { PurchaseAnalytics } from '../../../services/Analytics'
import { LOCATIONS_ROUTE } from '../../../utils/constants/Helpers'
import { HeaderTheme } from '../../../utils/types/appTypes'
import CommonHeader from '../../components/common-header'
import ConfirmedAppointmentContent from '../../components/confirmed-appointment'

type LocationState = {
  isFromShareAppointment?: boolean
}

const ConfirmedAppointment = () => {
  const location = useLocation()
  const { appMasterData, updateData } = useContext(AppContext)
  const { navigate } = useNavigate()

  const backToFunction = () => {
    navigate(LOCATIONS_ROUTE)
  }

  useEffect(() => {
    if (!(location.state as LocationState)?.isFromShareAppointment) {
      PurchaseAnalytics(appMasterData)
      triggerGA4Events('Booking', appMasterData)
      setTimeout(() => {
        updateData({
          ...appMasterData,
          cart: {
            ...appMasterData.cart,
            isPromoCodeApplied: false,
            promoCodes: [],
          },
        })
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <CommonHeader
        backToFunction={backToFunction}
        theme={HeaderTheme.ORANGE}
      />
      <ConfirmedAppointmentContent />
    </>
  )
}

export default ConfirmedAppointment
